/**
 * The origins a chapter frame's CSP allows, beside the publication URL Readium
 * adds itself. Firefox silently drops a CSP source whose path runs past about
 * 500 characters, which a signed publication URL does, so the publication's
 * origin has to be a source of its own.
 *
 * @param {string} publicationURL - Absolute URL of the publication
 * @param {string} readerOrigin - The reader's origin, for the fonts it serves
 * @returns {string[]}
 */
export const getFrameAllowedDomains = (publicationURL, readerOrigin) => {
    const { origin } = new URL(publicationURL);
    // A file:// URL has the opaque origin "null", which Readium refuses.
    // readiumPatches.js rewrites that frame's CSP instead.
    return origin === 'null' ? [readerOrigin] : [readerOrigin, origin];
};
